import { Text } from '@droplet-tech-code/core-elements/module/ui/Text';
import { PageHeader } from '~/components/Page/Page.Header';
import { translate } from '~/utils/translation.utils';

export const TrafficManagerItemHeader = ({ count }: { count: number }) => {
  return (
    <PageHeader
      title={translate('screens.trafficManagerPanel')}
      Subtitle={<Text.Small>{`${count} Queue Groups`}</Text.Small>}
    />
  );
};
